import React from "react";
import BaseForm from "../base/BaseForm";
import ProyectoAPI from "../../api/proyectos-api";
import PublicAPI from "../../api/public-api";
import historyHelper from "../../helpers/history-helper";

import File from "../form/File";
import Input from "../form/Input";
import { Messages } from "../../helpers/message-helper";
import Switch from "../form/Switch";
import {
  Panel,
  Description,
  Content,
  Wizard,
  Breadcrumb
} from "../layout/Panel";
import Fa from "../common/Fa";
import Form from "../form/Form";
import Select from "../form/Select";
import Auditoria from "../base/Auditoria";
import Alert from "../common/Alert";

const constraints = {
  nombre: {
    presence: {
      allowEmpty: false,
      message: Messages.get("Proyecto.validation.nombre.require")
    }
  },
  matricula: {
    presence: {
      allowEmpty: false,
      message: Messages.get("Proyecto.validation.matricula.require")
    }
  },
  id_distrito: {
    presence: {
      allowEmpty: false,
      message: Messages.get("Proyecto.validation.id_distrito.require")
    }
  },
  id_departamento: {
    presence: {
      allowEmpty: false,
      message: Messages.get("Proyecto.validation.id_departamento.require")
    }
  },
  padron: {
    presence: {
      allowEmpty: false,
      message: Messages.get("Proyecto.validation.padron.require")
    }
  }
};
const d = {
  propietarios: {
    array: {
      tipo_documento: {
        presence: {
          allowEmpty: false
        }
      },
      nro_documento: {
        presence: {
          allowEmpty: false
        }
      },
      nombres: {
        presence: {
          allowEmpty: false
        }
      },
      direccion: {
        presence: {
          allowEmpty: false
        }
      }
    }
  },
  zona: {
    presence: {
      allowEmpty: false,
      message: Messages.get("Proyecto.validation.zona.require")
    }
  },
  manzana: {
    presence: {
      allowEmpty: false,
      message: Messages.get("Proyecto.validation.manzana.require")
    }
  },
  lote: {
    presence: {
      allowEmpty: false,
      message: Messages.get("Proyecto.validation.lote.require")
    }
  }
};
/**
 * Componente que representa el formulario de alta y modificación
 * de un proyecto.
 */
export default class ProyectoForm extends BaseForm {
  state = {
    validate: false,
    loading: false,
    urbano: false,
    rural: true,
    id_departamento: "L",
    id_distrito: 1,
    distritos: [],
    departamentos: [],
    propietarios: [{}]
  };
  /**
   * Mensajes de la aplicación.
   * @field
   */
  message = {
    "confirm.message": "Proyecto.agregar.confirm",
    "agregar.success": "Proyecto.agregar.success",
    "agregar.error": "Proyecto.agregar.error"
  };

  /**
   * @constructor
   */
  constructor(props) {
    super(props);
    this.api = ProyectoAPI;
    this.sieca = PublicAPI;
  }

  /**
   * Se encarga de recupera los datos de los distritos y departamentos
   * cuando el componente se monta.
   */
  componentDidMount() {
    super.componentDidMount();
    this.getDepartamentos();
    this.getDistritos();
  }

  /**
   * Se encarga de invocar al servicio que se encarga de guardar
   * un registro.
   */
  guardar(state) {
    let data = Object.assign({}, this.state);
    delete data.distritos;
    delete data.departamentos;
    super.guardar(data);
  }

  /**
   * Se encarga de validar la cuenta corriente y/o padón.
   */
  validarCuenta(evt) {
    let data = Object.assign({}, this.state);
    delete data.distritos;
    delete data.departamentos;
    data.dpto = this.state.id_departamento;
    data.dist = this.state.id_distrito;

    PublicAPI.cuentas(data)
      .then(response => {
        let data = response.data;
        var m2 =
          typeof data.superficieM2 !== "undefined"
            ? data.superficieM2
            : data.metrosCuadrados;
            console.log(data, m2);
        this.setState({
          validate: true,
          departamento: data.departamento,
          distrito: data.distrito,
          superficie: m2
        });
        //this.setState(data);
      })
      .catch(error => {
        console.error(error);
        this.setState({ validate: false });
      });
  }
  /**
   * Se encarga de manejar el success del guardar de los datos.
   * @param {*} data
   */
  guardarSuccess(data) {
    super.guardarSuccess(data);
    historyHelper.push({
      pathname: "/proyectos"
    });
  }

  /**
   * Se encarga de recuperar la lista de departamentos disponibles.
   */
  getDepartamentos() {
    this.sieca
      .departamentos()
      .then(response => {
        this.setState({ departamentos: response.data });
      })
      .catch(error => {
        console.error(error);
      });
  }
  /**
   * Se encarga de recupera la lista de distriots disponibles.
   */
  getDistritos() {
    this.sieca
      .distritos()
      .then(response => {
        this.setState({ distritos: response.data });
      })
      .catch(error => {
        console.error(error);
      });
  }
  /**
   * Se encarga de manejar el comportamiento de los radio buttons.
   * @param {*} value
   */
  changeSwitch(value) {
    this.setState(prevState => ({
      urbano: !prevState.urbano,
      rural: !prevState.rural,
      padron: !prevState.rural ? "" : undefined,
      zona: !prevState.urbano ? "" : undefined,
      manzana: !prevState.urbano ? "" : undefined,
      lote: !prevState.urbano ? "" : undefined
    }));
  }

  /**
   * Se encarga de renderizar el combo box de distritos según el
   * departamento seleccionado.
   */
  renderDistritos() {
    const { distritos, id_departamento, id_distrito } = this.state;
    const idDist = this.isCrear() ? undefined : id_distrito;
    let dist = distritos.filter(d => {
      return d.id_departamento === id_departamento;
    });
    return (
      <Select
        label="Distritos"
        placeholder="Distritos"
        value={idDist}
        validations={constraints.id_distrito}
        name="id_distrito"
        help="Seleccione el distrito donde se encuentra ubicado el inmueble."
        onChange={val => this.onChange("id_distrito", val)}
      >
        {dist.map(option => {
          return (
            <option key={option.id_distrito} value={option.id_distrito}>
              {option.id_distrito} - {option.descripcion}
            </option>
          );
        })}
      </Select>
    );
  }

  /**
   * Se encarga de renderizar el combo box de departamentos.
   */
  renderDepartamentos() {
    const { departamentos, id_departamento } = this.state;
    return (
      <Select
        label="Departamentos"
        placeholder="Departamentos"
        value={id_departamento}
        validations={constraints.id_departamento}
        name="id_departamento"
        onChange={val => this.onChange("id_departamento", val)}
        help="Seleccione el departamento donde se encuentra ubicado el inmueble."
      >
        {departamentos.map(option => (
          <option key={option.id_departamento} value={option.id_departamento}>
            {option.id_departamento} - {option.descripcion}
          </option>
        ))}
      </Select>
    );
  }
  /**
   * Se encarga de renderizar el partial correspondients a una cuenta
   * rutal o una cuenta corriente.
   */
  renderCuentas() {
    const { urbano } = this.state;
    if (!urbano) {
      return (
        <Input
          type="number"
          value={this.state.padron}
          label="Padrón"
          placeholder="Ingrese el número de padrón"
          help="Número de padrón del inmueble."
          validations={constraints.padron}
          name="padron"
          onChange={val => this.onChange("padron", val)}
        />
      );
    } else {
      return (
        <div className="columns">
          <div className="column">
            <Input
              type="number"
              value={this.state.zona}
              label="Zona"
              placeholder="Ingrese el número de zona"
              help="Número de zona del inmueble."
              validations={constraints.zona}
              name="zona"
              onChange={val => this.onChange("zona", val)}
            />
          </div>
          <div className="column">
            <Input
              type="number"
              value={this.state.mazana}
              label="Manzana"
              placeholder="Ingrese el número de mazana"
              help="Número de mazana del inmueble."
              validations={constraints.manzana}
              name="manzana"
              onChange={val => this.onChange("mazana", val)}
            />
          </div>
          <div className="column">
            <Input
              type="number"
              value={this.state.lote}
              label="Lote"
              placeholder="Ingrese el número de lote"
              help="Número de lote del inmueble."
              validations={constraints.lote}
              name="lote"
              onChange={val => this.onChange("lote", val)}
            />
          </div>
        </div>
      );
    }
  }
  /**
   * Se encarga de renderizar el selector de tipo de cuentas y los combos box
   * de departamentos y distritios.
   */
  renderTipoCuenta() {
    return (
      <React.Fragment>
        <hr />
        <h3>Datos del inmueble</h3>
        <p>
          Datos la finca matriz utilizada. El sistema validará que los datos del
          inmueble concindan con los datos registrados en el SNC.
        </p>
        <div className="columns">
          <div className="column">
            <div className="field" id="selector-tipo-cuenta">
              <label className="label">Tipo de cuenta</label>
              <Switch
                className="form-check-input"
                placeholder="Cuentas corrientes"
                value={this.state.urbano}
                handleChange={this.changeSwitch.bind(this)}
              />
              <Switch
                className="form-check-input"
                placeholder="Cuentas Rurales"
                value={this.state.rural}
                handleChange={this.changeSwitch.bind(this)}
              />
              <p className="help">Seleccione el tipo de inmueble.</p>
            </div>
          </div>
          <div className="column">{this.renderDepartamentos()}</div>
          <div className="column">{this.renderDistritos()}</div>
          <div className="column is-6">{this.renderCuentas()}</div>
        </div>
        <a
          className="button is-outlined"
          onClick={evt => this.validarCuenta(evt)}
        >
          <Fa icon="search-location" />
          Validar Cuenta
        </a>
      </React.Fragment>
    );
  }

  /**
   * Se enarga de renderizar la lista de propietarios.
   */
  renderListPropietarios() {
    return this.state.propietarios.map((p, index) => {
      return (
        <React.Fragment key={index}>
          <div className="columns">
            <div className="column">
              <Select
                label={`#${index + 1} Tipo documento`}
                placeholder="Tipo documento"
                value={p.tipo_documento}
                onChange={val =>
                  this.handlePropietarios(
                    "change",
                    index,
                    "tipo_documento",
                    val
                  )
                }
                help="Tipo de documento del propietario del inmueble."
              >
                <option key="CI" value="CI">
                  Cédula de Identidad
                </option>
                <option key="RUC" value="RUC">
                  RUC
                </option>
              </Select>
            </div>

            <div className="column">
              <Input
                type="text"
                value={p.nro_documento}
                label="Nro Documento"
                placeholder="Propietario el nro de documento del propietario del inmueble"
                help="Propietario del inmueble."
                onChange={val =>
                  this.handlePropietarios("change", index, "nro_documento", val)
                }
              />
            </div>
            <div className="column">
              <Input
                type="text"
                value={p.nombres}
                label="Propietario"
                placeholder="Propietario del inmueble del inmueble"
                help="Propietario del inmueble."
                onChange={val =>
                  this.handlePropietarios("change", index, "nombres", val)
                }
              />
            </div>
            <a onClick={evt => this.handlePropietarios("del", index)}>
              <Fa icon="trash" />
            </a>
          </div>
          <Input
            type="text"
            value={p.domicilio}
            label="Domicilio"
            placeholder="Ingrese el domicilio del propietario del inmueble del inmueble"
            help="Domicilio personal/juridico del propietario del inmueble."
            onChange={val =>
              this.handlePropietarios("change", index, "direccion", val)
            }
          />
          <hr />
        </React.Fragment>
      );
    });
  }
  /**
   *  Se encarag de manejar los eventos para agregar o eliminar elementos
   * del array de propietarios.
   *
   * @param {string} type tipo de evento
   * @param {number} idx el indice del evnto
   * @param {string} [key] la clave del atributo a modificar
   * @param {object} [value] el valor del nuevo objeto
   */
  handlePropietarios(type, idx, key, value) {
    this.setState(prevState => {
      if (type === "add") {
        prevState.propietarios.push({});
      } else if (type === "del") {
        prevState.propietarios.splice(idx, 1);
      } else if (type === "change") {
        prevState.propietarios[idx][key] = value;
      }
      return prevState;
    });
  }
  /**
   * Se encarga de renderizar el form de datos del propietario del inmueble.
   */
  renderPropietarios() {
    return (
      <React.Fragment>
        <hr />
        <h3>Datos de los Propietarios del inmueble</h3>
        <a onClick={evt => this.handlePropietarios("add")}>
          <Fa icon="plus" />
        </a>
        {this.renderListPropietarios()}
      </React.Fragment>
    );
  }

  /**
   * Se encarga de renderizar los elementos del formulario.
   */
  renderFields() {
    return (
      <React.Fragment>
        <label>Superficie: {this.state.superficie}</label>
        <label>Departamento: {this.state.departamento}</label>
        <label>Distrito: {this.state.distrito}</label>
        <Input
          type="text"
          value={this.state.nombre}
          label="Nombre"
          placeholder="Ingrese nombre del Proyecto"
          help="Nombre del proyecto."
          validations={constraints.nombre}
          name="nombre"
          onChange={val => this.onChange("nombre", val)}
        />
        <Input
          type="text"
          value={this.state.matricula}
          label="Matricula"
          placeholder="Matricula del inmueble"
          help="Número de matricula del inmueble."
          validations={constraints.matricula}
          name="matricula"
          onChange={val => this.onChange("matricula", val)}
        />
      </React.Fragment>
    );
  }

  /**
   * Se encarga de renderizar los componentes de carga de archivos.
   */
  renderFiles() {
    return (
      <React.Fragment>
        <h3>Planos</h3>
        <p>
          Debe adjuntar el plano en formato shapefile en formato shp, shx, bdf y
          prj para crear el proyecto. Es sistema permitirá previsualizar la
          integración de el plano en el parcelario del SNC.
        </p>
        <br />

        <File
          onChange={file => this.setFile("plano_shp", file)}
          label="Cargar Plano shp"
          accept=".shp"
          help="Debe adjuntar el archivo en formato shapefile correspondiente al proyecto."
        />

        <File
          onChange={file => this.setFile("plano_shx", file)}
          accept=".shx"
          label="Cargar Plano shx"
          help="Debe adjuntar el archivo en formato shapefile correspondiente al proyecto."
        />

        <File
          accept=".dbf"
          onChange={file => this.setFile("plano_dbf", file)}
          label="Cargar Plano dbf"
          help="Debe adjuntar el archivo en formato shapefile correspondiente al proyecto."
        />

        <File
          accept=".prj"
          onChange={file => this.setFile("plano_prj", file)}
          label="Cargar Plano prj"
          help="Debe adjuntar el archivo en formato shapefile correspondiente al proyecto."
        />
      </React.Fragment>
    );
  }

  renderProyecto() {
    return (
      <div className="columns">
        <div className="column">
          {this.state.validate && this.renderFields()}
          {this.state.validate && this.renderPropietarios()}
        </div>
        <div className="column is-1" />

        <div className="column is-5">
          {this.isCrear() && this.renderFiles()}
        </div>
        <hr />
      </div>
    );
  }

  /**
   * Se encarga de renderizar el componente
   */
  render() {
    return (
      <React.Fragment>
        <Wizard>
          <Breadcrumb badge="1">Proyectos</Breadcrumb>
          <Breadcrumb active badge="2">
            Gestionar Proyectos
          </Breadcrumb>
          <Breadcrumb badge="3">Consultar Proyecto</Breadcrumb>
        </Wizard>
        <Panel title="Proyectos">
          <Description>
            A travéz de esta pantalla podrás gestionar los datos de los
            proyectos.
          </Description>
          <Content>
            <Alert onRef={ref => (this.alert = ref)} />
            <Form onRef={ref => (this.form = ref)} validations={constraints}>
              <div className="columns">
                <div>{!this.state.loading && this.renderTipoCuenta()}</div>
              </div>
              <hr />
              {this.state.validate && this.renderProyecto()}
            </Form>
          </Content>
          <hr />
          <p clas="help">
            <Fa icon="info-circle" />
            Al crear un proyecto, podrás previsualizar la integración con el
            parcelario, el proyecto quedará en un estado inicial{" "}
            <code>Creada</code>, solo tu la podrás ver. Para que tu proyecto sea
            procesado por el equipo del SNC, deberás <code>Remitir</code> tu
            proyecto.
          </p>
          <hr />
          <div className="control">
            <a
              className="button is-primary is-outlined"
              onClick={evt => this.onGuardar(evt)}
            >
              <Fa icon="save" />
              &nbsp;{this.isCrear() && "Crear Proyecto"}
              {!this.isCrear() && "Guardar Proyecto"}
            </a>
          </div>
          <hr />
          <a className="button">
            <Fa icon="arrow-left" />
            Atras
          </a>
        </Panel>
      </React.Fragment>
    );
  }
}
